/**
 * Shared Tailwind classes for `ReadAloudBar`/`ReadAloudVoiceMenu`'s icon-only
 * buttons — the round `ReadIconAction` look (40px so mobile hit-targets stay
 * >=40px per read-mode.listen spec §3, vs. `ReadIconAction`'s own 36px),
 * duplicated rather than reused because `ReadIconAction` renders its label
 * as a hover tooltip only, while these buttons sometimes need visible text
 * next to the icon (the "1×" speed button).
 */
export const readAloudIconButtonClass =
  'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-input bg-background text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50'
